import React, {useContext } from 'react'
import { Card, CardContent, CardHeader, Typography, Grid, Divider } from '@material-ui/core'

import useStyles from './styles'
import Form from './form/Form'
import List from './list/List'
import InfoCard from '../InfoCard'
import { ExpenseTrackerContext } from '../../context/context'

const Main = () => {

    const classes = useStyles()
    const { balance } = useContext(ExpenseTrackerContext)

    return (
        <Card className={classes.root}>
            <CardHeader
                title="Expense Tracker"
                subheader="Powered By Speechly"
            />

            <CardContent>
                <Typography align='center' variant='h5'>
                    Total Balance ${balance}
                </Typography>
                
                <Typography variant='subtitle1' style={{ lineHeight: '1.5em', marginTop: '20px' }}>
                    <InfoCard />
                </Typography>

                <Divider className={classes.divider} />

                <Form />
            </CardContent>

            <CardContent className={classes.cartContent}>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <List />
                    </Grid>
                </Grid>
            </CardContent>
        </Card>
    )
}

export default Main
